<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-header class="right-menu-name"
               height="20px">
      <!-- 个人中心/{{$route.meta.title}} -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="sjz" v-if="detailInfo.demandVo && detailInfo.demandVo.status === 5">
      <div :class="index===(stepsDemand.length-1)?'sjz-item':'sjz-kuaikuai'"
           v-for="(item, index) in stepsDemand"
           :key="index">
        <div class="sjz-item">
          <div :class="'sjz-icon '+ ((index>activeIndex)?'sjz-undone':(index===activeIndex)?'sjz-do':'')">
            <i class="el-icon-check"
               style="width:40px;height:40px;"
               v-if="index<activeIndex"></i>
            <span class="sjc-num sjc-do"
                  v-else-if="index===activeIndex">{{index+1}}</span>
            <span class="sjc-num"
                  v-else-if="index>activeIndex">{{index+1}}</span>
          </div>
          <div class="sjz-word">{{item.name}}</div>
        </div>
        <div :class="'sjz-line '+((index>=activeIndex)?'sjz-undone':'')"
             v-if="index!==(stepsDemand.length-1)"></div>
      </div>
    </div>
    <div class="sjz" v-else>
      <div :class="index===(steps.length-1)?'sjz-item':'sjz-kuaikuai'"
           v-for="(item, index) in steps"
           :key="index">
        <div class="sjz-item">
          <div :class="'sjz-icon '+ ((index>activeIndex)?'sjz-undone':(index===activeIndex)?'sjz-do':'')">
            <i class="el-icon-check"
               style="width:40px;height:40px;"
               v-if="index<activeIndex"></i>
            <span class="sjc-num sjc-do"
                  v-else-if="index===activeIndex">{{index+1}}</span>
            <span class="sjc-num"
                  v-else-if="index>activeIndex">{{index+1}}</span>
          </div>
          <div class="sjz-word">{{item.name}}</div>
        </div>
        <div :class="'sjz-line '+((index>=activeIndex)?'sjz-undone':'')"
             v-if="index!==(steps.length-1)"></div>
      </div>
    </div>
    <!-- 需求单基本信息 -->
    <div class="body-info">
      <div style="position:relative;">
        <h2 style="display: inline-block;">需求单基本信息</h2>
        <span style="position:absolute;right:0;padding:5px 20px;border: 1px solid #1D65A8;border-radius: 15px;font-size: 14px;color: #333333;">
          单据状态：
          <span v-if="detailInfo.demandVo && detailInfo.demandVo.status===5">已关闭</span>
          <span v-else-if="detailInfo.demandStatus === undefined">待受理</span>
          <span v-else-if="detailInfo.demandStatus===null || detailInfo.demandStatus===0 || detailInfo.demandStatus===1">处理中</span>
          <span v-else-if="detailInfo.demandStatus===2">待确认</span>
          <span v-else-if="detailInfo.demandStatus==3">待签收</span>
          <span v-else-if="detailInfo.demandStatus===4">完工待付款</span>
          <span v-else-if="detailInfo.demandStatus===5">完工已付款</span>
          <span v-else-if="detailInfo.demandStatus===6">已撤销</span>
          <span v-else-if="detailInfo.demandStatus===7">已退回</span>
        </span>
      </div>
      <div v-if="detailInfo.demandId"
           class="demand-info">
        <div class="demand-back">
          <div class="row">
            <div class="row-item">
              <span class="row-item-label">单据编号：</span>
              <label class="row-item-input">{{detailInfo.demandCode}}</label>
            </div>
            <div class="row-item">
              <span class="row-item-label">需求分类：</span>
              <label class="row-item-input">{{detailInfo.demandType}}</label>
            </div>
            <div class="row-item">
              <span class="row-item-label">录入人：</span>
              <label class="row-item-input">
                <!-- {{detailInfo.inputPersonType}} -->
                <span v-if="detailInfo.typingPerson===0">个人录入</span>
                <span v-else-if="detailInfo.typingPerson===1">5s店代录</span>
                <span v-else-if="detailInfo.typingPerson===2">总部运营代录</span>
                <span v-else-if="detailInfo.typingPerson===3">客服代录</span>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="row-item">
              <span class="row-item-label">联系人：</span>
              <label class="row-item-input">{{detailInfo.contacts}}</label>
            </div>
            <div class="row-item">
              <span class="row-item-label">手机号：</span>
              <label class="row-item-input">{{detailInfo.contactNumber}}</label>
            </div>
            <div class="row-item">
              <span class="row-item-label">提交时间：</span>
              <label class="row-item-input">{{detailInfo.createTime}}</label>
            </div>
          </div>
          <div class="row">
            <span class="row-item-label">公司名称：</span>
            <label class="row-item-textarea demand-textarea"
                   style="margin-bottom: 0;">{{detailInfo.clientCorporate}}</label>
          </div>
          <div class="row"
               style="">
            <span class="row-item-label">服务场所：</span>
            <label class="row-item-textarea demand-textarea">{{detailInfo.place}}</label>
          </div>
        </div>
        <div class="row"
             style="">
          <span class="row-item-label">需求描述：</span>
          <label class="row-item-textarea demand-textarea">{{detailInfo.demandDescribe}}</label>
        </div>
        <div class="row">
          <!-- 文档 -->
          <ul v-if="detailInfo.ossFiles"
              class="inquiryfj">
            <li v-for="(item, index) in detailInfo.ossFiles"
                :key="index"
                @click.stop="download(item)">
              <img v-if="item.fileType === 'docx'"
                   :src="BASE_URL + 'img/word.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'doc'"
                   :src="BASE_URL + 'img/word.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'zip'"
                   :src="BASE_URL + 'img/zip.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'xls'"
                   :src="BASE_URL + 'img/excel.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'xlsx'"
                   :src="BASE_URL + 'img/excel.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'pdf'"
                   :src="BASE_URL + 'img/ppf.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'ppt' || item.fileType === 'pptx'"
                   :src="BASE_URL + 'img/ppt.png'"
                   :alt="item.fileName" />
              <img :alt="item.fileName"
                   v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                   :src="item.objectName">
              <img v-else
                   :src="BASE_URL + 'img/zwt.png'"
                   width="95px"
                   height="95px"
                   :alt="item.fileName" />
              <el-tooltip class="item"
                          effect="dark"
                          :content="item.fileName"
                          placement="top-start">
                <p class="overell">{{item.fileName}}</p>
              </el-tooltip>
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="detailInfo.demandVo"
           class="demand-info">
        <div class="demand-back">
          <div class="row">
            <div class="row-item">
              <span class="row-item-label">单据编号：</span>
              <label class="row-item-input">{{detailInfo.demandVo.demandCode}}</label>
            </div>
          </div>
          <div class="row">
            <div class="row-item">
              <span class="row-item-label">提交时间：</span>
              <label class="row-item-input">{{detailInfo.demandVo.createTime}}</label>
            </div>
          </div>
          <div class="row">
            <span class="row-item-label">公司名称：</span>
            <label class="row-item-textarea demand-textarea"
                   style="margin-bottom: 0;">{{detailInfo.demandVo.companyName}}</label>
          </div>
          <div class="row"
               style="">
            <span class="row-item-label">服务场所：</span>
            <label class="row-item-textarea demand-textarea">
              {{detailInfo.demandVo.province + detailInfo.demandVo.city + detailInfo.demandVo.area + detailInfo.demandVo.address}}
            </label>
          </div>
        </div>
        <div class="row"
             style="">
          <span class="row-item-label">需求描述：</span>
          <label class="row-item-textarea demand-textarea">{{detailInfo.demandVo.demandDescribe}}</label>
        </div>
        <div class="row">
          <!-- 文档 -->
          <ul v-if="detailInfo.demandVo.ossFiles"
              class="inquiryfj">
            <li v-for="(item, index) in detailInfo.demandVo.ossFiles"
                :key="index"
                @click.stop="download(item)">
              <img v-if="item.fileType === 'docx'"
                   :src="BASE_URL + 'img/word.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'doc'"
                   :src="BASE_URL + 'img/word.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'zip'"
                   :src="BASE_URL + 'img/zip.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'xls'"
                   :src="BASE_URL + 'img/excel.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'xlsx'"
                   :src="BASE_URL + 'img/excel.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'pdf'"
                   :src="BASE_URL + 'img/ppf.png'"
                   :alt="item.fileName" />
              <img v-else-if="item.fileType === 'ppt' || item.fileType === 'pptx'"
                   :src="BASE_URL + 'img/ppt.png'"
                   :alt="item.fileName" />
              <img :alt="item.fileName"
                   v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                   :src="item.objectName">
              <img v-else
                   :src="BASE_URL + 'img/zwt.png'"
                   width="95px"
                   height="95px"
                   :alt="item.fileName" />
              <el-tooltip class="item"
                          effect="dark"
                          :content="item.fileName"
                          placement="top-start">
                <p class="overell">{{item.fileName}}</p>
              </el-tooltip>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 关闭原因 -->
    <div class="body-info"
         v-if="detailInfo && detailInfo.demandVo && detailInfo.demandVo.status===5">
         <h2 style="display: inline-block;">客服受理情况</h2>
      <div class="demand-detail-info box-shadow">
        <div class="right-content"
             style="width:1050px">
          <div class="row">
            <span class="row-item-label">关单备注：</span>
            <label class="row-item-conent"
                   style="line-height:30px;">{{detailInfo.demandVo.remarks}}</label>
          </div>
        </div>
      </div>
    </div>
    <!-- 退回原因 -->
    <div class="body-info"
         v-if="detailInfo && detailInfo.demandStatus === 7">
      <div class="demand-detail-info box-shadow">
        <div class="right-content"
             style="width:1050px">
          <div class="row">
            <span class="row-item-label">退回原因：</span>
            <label class="row-item-conent"
                   style="line-height:30px;">{{detailInfo.sendBackReason}}</label>
          </div>
        </div>
      </div>
    </div>
    <!--人员派遣情况 -->
    <div class="body-info"
         v-if="detailInfo && detailInfo.demandStatus > 0 && currentPerson">
      <h2>人员派遣情况</h2>
      <div class="demand-detail-info">
        <div class="current-acceptance-or">
          <img :src="currentPerson.acceptanceUserPic || defaultUserImg"
               alt="当前受理人" />
          <label class="current-label">当前受理人</label>
          <div class="current-info">
            <h3 class="current-name overell">姓名：{{currentPerson.acceptanceUserName}}</h3>
            <div class="current-tel overell">电话：{{currentPerson.acceptanceUserMobile}}</div>
            <div class="current-jobNum overell">工号：{{currentPerson.acceptanceUserCode}}</div>
            <div class="current-time overell">派遣时间：{{currentPerson.acceptanceTime}}</div>
          </div>
        </div>
        <div class="right-content"
             style="width:850px;padding-left:30px;padding-top:0;padding-bottom:0;">
          <h3>转单信息：</h3>
          <div class="history-list">
            <div :class="transferViewIndex === 0?'not-allow':''"
                 class="opt-left"
                 @click="transforward">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="viewWindow">
              <ul v-if="transferList"
                  class="transferList"
                  :style="{transform: 'translateX(' + trnasferDistance + ')'}">
                <li v-for="(item, index) in transferList"
                    :key="index"
                    style="width: 250px;">
                  <div class="history-info">
                    <div class="his-item">
                      <img width="217px"
                           height="140px"
                           :src="item.acceptanceUserPic || defaultUserImg"
                           :alt="item.acceptanceUserName" />
                      <div class="his-info">
                        <h3 class="his-name overell"
                            style="font-size:16px;divne-height:24px;">姓名：{{item.acceptanceUserName}}</h3>
                        <div class="his-tel overell">电话：{{item.acceptanceUserMobile}}</div>
                        <div class="his-jobNum overell">工号：{{item.acceptanceUserCode}}</div>
                        <div class="his-time overell">派遣时间：{{item.acceptanceTime}}</div>
                      </div>
                    </div>
                  </div>
                  <div style="width: 14px;"
                       v-if="index !== (transferList.length - 1)"
                       class="his-line">
                    <i class="el-icon-back"></i>
                  </div>
                </li>
              </ul>
            </div>
            <div :class="transferList.length <= 3 || transferViewIndex === (transferList.length - 3)?'not-allow':''"
                 class="opt-left opt-posation"
                 @click="transback">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务受理情况 -->
    <div class="body-info"
         v-if="detailInfo && detailInfo.serveAcceptance && detailInfo.demandStatus > 1">
      <h2>服务受理情况</h2>
      <div class="demand-detail-info box-shadow">
        <div class="left-label">
          <div class="label-vertical">服务受理单</div>
        </div>
        <div class="right-content">
          <h3>受理内容：</h3>
          <div class="row"
               style="flex-wrap: wrap;">
            <div class="row-detail-item">
              <span class="row-item-label">计划执行时间：</span>
              <label class="row-item-conent">{{detailInfo.serveAcceptance.planStartTime}}-{{detailInfo.serveAcceptance.planEndTime}}</label>
            </div>
          </div>
          <div class="row">
            <span class="row-item-label">客户需准备：</span>
            <label class="row-item-conent">{{detailInfo.serveAcceptance.needReadyContent}}</label>
          </div>
          <div class="row">
            <span class="row-item-label">服务内容：</span>
            <label class="row-item-conent">{{detailInfo.serveAcceptance.otherContent}}</label>
          </div>
          <div class="row">
            <div class="row-item">
              <span class="row-item-label">需求受理人：</span>
              <label class="row-item-conent">{{detailInfo.serveAcceptance.acceptanceUserName}}</label>
            </div>
            <div class="row-item">
              <span class="row-item-label">需求受理时间：</span>
              <label class="row-item-conent">{{detailInfo.serveAcceptance.acceptanceTime}}</label>
            </div>
          </div>
          <div class="row">
            <span class="row-item-label">附件：</span>
            <label class="row-item-conent">
              <!-- 文档 -->
              <ul v-if="detailInfo.serveAcceptance.ossFiles"
                  class="inquiryfj">
                <li v-for="(item, index) in detailInfo.serveAcceptance.ossFiles"
                    :key="index"
                    @click.stop="download(item)">
                  <img v-if="item.fileType === 'docx'"
                       :src="BASE_URL + 'img/word.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'doc'"
                       :src="BASE_URL + 'img/word.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'zip'"
                       :src="BASE_URL + 'img/zip.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'xls'"
                       :src="BASE_URL + 'img/excel.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'xlsx'"
                       :src="BASE_URL + 'img/excel.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'pdf'"
                       :src="BASE_URL + 'img/ppf.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'ppt' || item.fileType === 'pptx'"
                       :src="BASE_URL + 'img/ppt.png'"
                       :alt="item.fileName" />
                  <img :alt="item.fileName"
                       v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                       :src="item.objectName">
                  <img v-else
                       :src="BASE_URL + 'img/zwt.png'"
                       width="95px"
                       height="95px"
                       :alt="item.fileName" />
                  <el-tooltip class="item"
                              effect="dark"
                              :content="item.fileName"
                              placement="top-start">
                    <p class="overell">{{item.fileName}}</p>
                  </el-tooltip>
                </li>
              </ul>
            </label>
          </div>
        </div>
        <!-- <div class="end-confirm">
          <div v-if="detailInfo.demandStatus === 2">
            <div class="end-confirm-status">
              待客户确认
            </div>
            <div class="end-confirm-status">
              <button :class="'end-confirm-ok pointer ' + (subLoading?'but-loading':'')"
                      @click="confirmAcceptance()">
                <i class="el-icon-loading"
                   v-if="subLoading"></i>
                确认
              </button>
            </div>
          </div>
          <div v-else-if="detailInfo.demandStatus !== 6">
            <div class="end-confirm-status">
              <img :src="confirmImg"
                   alt="本人已确认" />本人已确认
            </div>
            <div class="end-confirm-time">
              确认时间：{{detailInfo.serveAcceptance.customerConfirmTime}}
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 实际工时详情 -->
    <div class="body-info"
         v-if="detailInfo && detailInfo.serveAcceptance && detailInfo.demandStatus >= 3">
      <div class="row"
           style="margin-bottom: 0px;">
        <div class="row-item"
             style="min-width:210px;">
          <span class="row-item-label">实际发生工时：</span>
          <label class="row-item-input">{{detailInfo.realWorkHour || 0}}小时</label>
        </div>
        <!-- <div class="row-item"
             style="width:210px; min-width:210px;">
          <span class="row-item-label">服务应收费用：</span>
          <label class="row-item-input">{{detailInfo.settlementPrice || 0}}元</label>
        </div>
        <div class="row-item"
             style="width:210px; min-width:210px;">
          <span class="row-item-label">实际应收费用：</span>
          <label class="row-item-input">{{detailInfo.actualReceivableAmount || 0}}元</label>
        </div> -->
        <div class="row-item"
             style="min-width:210px;">
          <span class="row-item-label">服务结果：</span>
          <label class="row-item-input">{{detailInfo.serviceStatus === 1 ? '完成' : '未完成' }}</label>
        </div>
        <div class="row-item"
             style="min-width:280px;">
          <span class="row-item-label">系统型号：</span>
          <label class="row-item-input">{{detailInfo.charParamG}}</label>
        </div>
      </div>
      <div class="row"
           style="margin-bottom: 0px;"
           v-if="detailInfo.diffPriceReason">
        <div class="row-item"
             style="width:100% ;">
          <span class="row-item-label">备注：</span>
          <label class="row-item-input"
                 style="width:100% ;">{{detailInfo.diffPriceReason}}</label>
        </div>
      </div>
    </div>
    <!-- 服务记录 -->
    <div class="body-info"
         v-if="detailInfo.demandServiceList && detailInfo.demandServiceList.length">
      <h2>服务签收情况</h2>
      <!-- 服务记录 -->
      <div class="demand-detail-info box-shadow"
           v-for="item in detailInfo.demandServiceList"
           :key="item.id">
        <div class="left-label left-label-fwjl">
          <div class="label-vertical">服务记录</div>
        </div>
        <div class="right-content"
             style="width:1050px">
          <div class="row">
            <span class="row-item-label">服务执行人：</span>
            <label class="row-item-conent">{{item.implementUserName}}</label>
          </div>
          <div class="row">
            <span class="row-item-label">实际执行时间：</span>
            <label class="row-item-conent">{{item.realStartTime}}-{{item.realEndTime}}</label>
          </div>
          <div class="row">
            <span class="row-item-label">服务记录：</span>
            <label class="row-item-conent"
                   style="max-width:850px">{{item.serviceContent}}</label>
          </div>
          <div class="row">
            <span class="row-item-label">附件：</span>
            <label class="row-item-conent">
              <!-- 文档 -->
              <ul v-if="item.ossFiles"
                  class="inquiryfj">
                <li v-for="(ele, index) in item.ossFiles"
                    :key="index"
                    @click.stop="download(ele)">
                  <img v-if="ele.fileType === 'docx'"
                       :src="BASE_URL + 'img/word.png'"
                       :alt="ele.fileName" />
                  <img v-else-if="ele.fileType === 'doc'"
                       :src="BASE_URL + 'img/word.png'"
                       :alt="ele.fileName" />
                  <img v-else-if="ele.fileType === 'zip'"
                       :src="BASE_URL + 'img/zip.png'"
                       :alt="ele.fileName" />
                  <img v-else-if="ele.fileType === 'xls'"
                       :src="BASE_URL + 'img/excel.png'"
                       :alt="ele.fileName" />
                  <img v-else-if="ele.fileType === 'xlsx'"
                       :src="BASE_URL + 'img/excel.png'"
                       :alt="ele.fileName" />
                  <img v-else-if="ele.fileType === 'pdf'"
                       :src="BASE_URL + 'img/ppf.png'"
                       :alt="ele.fileName" />
                  <img v-else-if="ele.fileType === 'ppt' || ele.fileType === 'pptx'"
                       :src="BASE_URL + 'img/ppt.png'"
                       :alt="ele.fileName" />
                  <img :alt="ele.fileName"
                       v-else-if="ele.fileType === 'bmp' || ele.fileType === 'jpg' || ele.fileType === 'png' || ele.fileType === 'gif' || ele.fileType === 'BMG' || ele.fileType === 'JPG' || ele.fileType === 'PNG' || ele.fileType === 'GIF'"
                       :src="ele.objectName">
                  <img v-else
                       :src="BASE_URL + 'img/zwt.png'"
                       width="95px"
                       height="95px"
                       :alt="ele.fileName" />
                  <el-tooltip class="item"
                              effect="dark"
                              :content="ele.fileName"
                              placement="top-start">
                    <p class="overell">{{ele.fileName}}</p>
                  </el-tooltip>
                </li>
              </ul>
            </label>
          </div>
        </div>
      </div>
      <!-- 签收情况 -->
      <div class="demand-detail-info box-shadow"
           v-if="detailInfo.demandStatus > 3 && detailInfo.demandStatus !== 6">
        <div class="left-label left-label-qsqk">
          <div class="label-vertical">签收情况</div>
        </div>
        <div class="right-content">
          <div class="row"
               style="position:relative;">
            <h3>客户评价信息：</h3>
            <div class="pointer wyts"
                 @click.stop="complaintVisible = true">我要投诉</div>
          </div>
          <div class="row">
            <div style="display:flex;">
              <span class="row-item-label">服务质量：</span>
              <label class="row-item-conent">
                <el-rate class="rate-choose-normal"
                         :disabled="true"
                         v-model="detailInfo.demandCustomerSign.serviceQuality"></el-rate>
              </label>
            </div>
            <div style="display:flex;">
              <span class="row-item-label">服务态度：</span>
              <label class="row-item-conent">
                <el-rate class="rate-choose-normal"
                         :disabled="true"
                         v-model="detailInfo.demandCustomerSign.serviceAttitude"></el-rate>
              </label>
            </div>
            <div style="display:flex;">
              <span class="row-item-label">服务响应：</span>
              <label class="row-item-conent">
                <el-rate class="rate-choose-normal"
                         :disabled="true"
                         v-model="detailInfo.demandCustomerSign.serviceResponse"></el-rate>
              </label>
            </div>
          </div>
          <div class="row">
            <span class="row-item-label">意见反馈：</span>
            <label class="row-item-conent">{{detailInfo.demandCustomerSign.feedbackContent}}</label>
          </div>
          <div class="row">
            <span class="row-item-label"></span>
            <label class="row-item-conent"
                   style="display: flex;">
              <div class="fj-item"
                   v-for="item in detailInfo.demandCustomerSign.ossFiles"
                   :key="item.id"
                   @click.stop="download(item)">
                <img v-if="item.fileType === 'docx'"
                     :src="BASE_URL + 'img/word.png'"
                     :alt="item.fileName" />
                <img v-else-if="item.fileType === 'doc'"
                     :src="BASE_URL + 'img/word.png'"
                     :alt="item.fileName" />
                <img v-else-if="item.fileType === 'zip'"
                     :src="BASE_URL + 'img/zip.png'"
                     :alt="item.fileName" />
                <img v-else-if="item.fileType === 'xls'"
                     :src="BASE_URL + 'img/excel.png'"
                     :alt="item.fileName" />
                <img v-else-if="item.fileType === 'xlsx'"
                     :src="BASE_URL + 'img/excel.png'"
                     :alt="item.fileName" />
                <img v-else-if="item.fileType === 'pdf'"
                     :src="BASE_URL + 'img/ppf.png'"
                     :alt="item.fileName" />
                <img v-else-if="item.fileType === 'ppt' || item.fileType === 'pptx'"
                     :src="BASE_URL + 'img/ppt.png'"
                     :alt="item.fileName" />
                <img :alt="item.fileName"
                     v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                     :src="item.objectName">
                <img v-else
                     :src="BASE_URL + 'img/zwt.png'"
                     width="95px"
                     height="95px"
                     :alt="item.fileName" />
                <el-tooltip class="item"
                            effect="dark"
                            :content="item.fileName"
                            placement="top-start">
                  <p class="overell">{{item.fileName}}</p>
                </el-tooltip>
              </div>
            </label>
          </div>
        </div>
        <div class="end-confirm">
          <div class="end-confirm-status">
            <img :src="confirmImg"
                 alt="客户已确认" />客户已确认
          </div>
          <div class="end-confirm-time">
            签收时间：{{detailInfo.demandCustomerSign.createTime}}
          </div>
        </div>
      </div>
      <!-- 服务签收单 确认 -->
      <div class="demand-detail-info box-shadow"
           v-if="detailInfo.demandStatus===3 && detailInfo.serviceStatus !== null">
        <div class="left-label left-label-qsqk">
          <div class="label-vertical">服务签收单</div>
        </div>
        <div class="right-content"
             style="width:1050px">
          <h3>客户评价信息：</h3>
          <div class="row"
               style="justify-content:space-between; padding-right:20px;">
            <div style="display:flex;">
              <span class="row-item-label">服务质量：</span>
              <label class="row-item-conent">
                <el-rate class="rate-choose"
                         v-model="customerEvaluate.serviceQuality"></el-rate>
              </label>
            </div>
            <div style="display:flex;">
              <span class="row-item-label">服务态度：</span>
              <label class="row-item-conent">
                <el-rate class="rate-choose"
                         v-model="customerEvaluate.serviceAttitude"></el-rate>
              </label>
            </div>
            <div style="display:flex;">
              <span class="row-item-label">服务响应：</span>
              <label class="row-item-conent">
                <el-rate class="rate-choose"
                         v-model="customerEvaluate.serviceResponse"></el-rate>
              </label>
            </div>
          </div>
          <div class="row">
            <span class="row-item-label">意见反馈：</span>
            <label class="row-item-conent"
                   style="max-width:880px; width:880px;">
              <el-input type="textarea"
                        maxlength="1000"
                        :autosize="{ minRows: 4}"
                        placeholder="请输入内容"
                        v-model="customerEvaluate.feedbackContent"></el-input>
            </label>
          </div>
          <div class="row">
            <span class="row-item-label">上传附件：</span>
            <div class="row-item-conent"
                 style="max-width:600px; width:860px;">
              <el-upload class="upload-demo"
                         :action="action"
                         :before-remove="removeFile"
                         :on-success="successFile"
                         :on-error="errorFile"
                         ref="upLoadFile"
                         multiple
                         :data="{ fileSuffixType: 'allType' }"
                         :accept="'.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx,.doc,.docx,.csv,.txt,.pdf,.zip,.rar,.ppt,.pptx'"
                         :before-upload="beforeUpload"
                         :file-list="fileList">
                <el-button size="small"
                           type="primary">点击上传</el-button>
                <div slot="tip"
                     class="el-upload__tip">上传文件不超过100MB</div>
              </el-upload>
              <!-- :http-request="uploadOss" -->
            </div>
          </div>
        </div>
      </div>
      <!-- 投诉信息 -->
      <template v-if="detailInfo && detailInfo.demandComplaint">
        <div class="demand-detail-info box-shadow"
             v-for="itemComplaint in detailInfo.demandComplaint"
             :key="itemComplaint.id">
          <div class="left-label left-label-tsxx">
            <div class="label-vertical">投诉信息</div>
          </div>
          <div class="right-content"
               style="width:1050px">
            <div class="row">
              <span class="row-item-label">问题描述：</span>
              <label class="row-item-conent"
                     style="max-width:850px;line-height:30px;">{{itemComplaint.complaintContent}}</label>
            </div>
            <div class="row">
              <span class="row-item-label"></span>
              <label class="row-item-conent"
                     style="display: flex;">
                <div class="fj-item"
                     v-for="item in itemComplaint.ossFiles"
                     :key="item.id">
                  <img v-if="item.fileType === 'docx'"
                       :src="BASE_URL + 'img/word.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'doc'"
                       :src="BASE_URL + 'img/word.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'zip'"
                       :src="BASE_URL + 'img/zip.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'xls'"
                       :src="BASE_URL + 'img/excel.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'xlsx'"
                       :src="BASE_URL + 'img/excel.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'pdf'"
                       :src="BASE_URL + 'img/ppf.png'"
                       :alt="item.fileName" />
                  <img v-else-if="item.fileType === 'ppt' || item.fileType === 'pptx'"
                       :src="BASE_URL + 'img/ppt.png'"
                       :alt="item.fileName" />
                  <img :alt="item.fileName"
                       v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                       :src="item.objectName">
                  <img v-else
                       :src="BASE_URL + 'img/zwt.png'"
                       width="95px"
                       height="95px"
                       :alt="item.fileName" />
                  <el-tooltip class="item"
                              effect="dark"
                              :content="item.fileName"
                              placement="top-start">
                    <p class="overell">{{item.fileName}}</p>
                  </el-tooltip>
                </div>
              </label>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 服务签收单 确认按钮 -->
    <div v-if="detailInfo "
         style="width:100%;text-align:center; display:flex;justify-content: center;padding:20px 0;">
      <div v-if="detailInfo.demandStatus === 3 && detailInfo.serviceStatus !== '' && detailInfo.serviceStatus !== null"
           :class="'pointer sign-but ' + (subLoading?'but-loading':'')"
           @click="signConfirm()">
        <i class="el-icon-loading"
           v-if="subLoading"></i>
        确认签收
      </div>
      <!-- <div v-if="detailInfo.demandStatus <= 1" :class="'pointer cancle-but ' + (subLoading?'but-loading':'')" @click="deleteDemand()">
        <i class="el-icon-loading" v-if="subLoading"></i>
        删除
      </div> -->
      <!-- <div v-if="detailInfo.demandStatus === 3" :class="'pointer cancle-but ' + (subLoading?'but-loading':'')" @click="revokeDemand()">
        <i class="el-icon-loading" v-if="subLoading"></i>
        撤销
      </div> -->
    </div>
    <!-- 操作日志 -->
    <div class="body-info"
         v-if="detailInfo&&detailInfo.demandPipelineRecord">
      <h2>操作日志</h2>
      <div class="timeline">
        <div class="timeline-small">
          <div class="timeline-small-body">
            <div class="line"
                 :style="{'bottom': getLineBottom}"></div>
            <ul>
              <li v-for="item in detailInfo.demandPipelineRecord"
                  :key="item.id"
                  class="timeline-small-body-ul-li">
                <div class="bullet pink"></div>
                <div class="date">{{item.createTime || ''}}</div>
                <!-- <div class="jg-distance"></div> -->
                <div class="desc">
                  <!-- <div class="record-time">09:00:23</div> -->
                  <div class="jg-distance"></div>
                  <div class="record-status">{{item.demandOperationContent || ''}}</div>
                  <div class="jg-distance"></div>
                  <div class="record-info">{{item.userContent || ''}}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 投诉 -->
    <el-dialog title="我要投诉"
               :visible.sync="complaintVisible"
               width="530px"
               class="doc-upload-area"
               :close-on-click-modal='false'
               :before-close="cancelUpload">
      <div class="row">
        <span class="row-item-label">问题描述：</span>
        <label class="row-item-conent"
               style="max-width:390px; width:390px;">
          <el-input type="textarea"
                    maxlength="1000"
                    :autosize="{ minRows: 4}"
                    placeholder="请输入内容"
                    v-model="complaintData.complaintContent"></el-input>
        </label>
      </div>
      <div class="row">
        <span class="row-item-label">附件上传：</span>
        <div class="row-item-conent"
             style="max-width:390px; width:390px;">
          <el-upload class="upload-demo"
                     :action="action"
                     :before-remove="removeFile"
                     :on-success="successFile"
                     :on-error="errorFile"
                     ref="upLoadFile"
                     multiple
                     :data="{ fileSuffixType: 'allType' }"
                     :accept="'.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx,.doc,.docx,.csv,.txt,.pdf,.zip,.rar,.ppt,.pptx'"
                     :before-upload="beforeUpload"
                     :file-list="fileList">
            <el-button size="small"
                       type="primary">点击上传</el-button>
            <div slot="tip"
                 class="el-upload__tip">上传文件不超过100MB</div>
          </el-upload>
        </div>
      </div>
      <div style="display:flex;margin-top: 40px;width: 530px;margin-left: -20px;margin-bottom: -30px;font-size: 16px;border: 1px solid #1D65A8;cursor: pointer;">
        <div :class="'upload-cancel ' + (subLoading?'but-loading':'')"
             style=" flex: 1;text-align: center;line-height: 52px;color: #1D65A8;"
             @click="cancelUpload()">
          <i class="el-icon-loading"
             v-if="subLoading"></i>
          取消投诉
        </div>
        <div :class="'but-complaint ' + (subLoading?'but-loading':'')"
             style=""
             @click="submitUpload()">
          <i class="el-icon-loading"
             v-if="subLoading"></i>
          确认投诉
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      confirmImg: require('../../../assets/img/confirm.svg'),
      defaultUserImg: require('@/assets/img/icon.jpg'),
      action: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/v2/upload',
      headerMsg: {
        token: getAccessToken()
      },
      subFlag: false,
      subLoading: false,
      complaintVisible: false, // 投诉dialog
      detailInfo: {
        demandCode: '',
        demandTypeId: '',
        typingPersonId: '',
        contacts: '',
        contactNumber: '',
        enterpriseId: '',
        createTime: '',
        address: '',
        demandDescribe: ''
      },
      activeIndex: 0,
      steps: [
        {
          ind: 1,
          key: '',
          name: '需求单提交'
        }, {
          ind: 2,
          key: '',
          name: '人员派遣'
        }, {
          ind: 3,
          key: '',
          name: '服务受理'
        }, {
        //   ind: 4,
        //   key: '',
        //   name: '受理确认'
        // }, {
          ind: 5,
          key: '',
          name: '服务签收'
        }, {
          ind: 6,
          key: '',
          name: '已结算'
        }
      ],
      stepsDemand: [
        {
          ind: 1,
          key: '',
          name: '需求单提交'
        }, {
          ind: 2,
          key: '',
          name: '已关闭'
        }
      ],
      textarea: '',
      transferViewIndex: 0,
      trnasferDistance: '0px',
      currentPerson: '', // 当前受理人
      transferList: [
        {
          name: '李小璐',
          phone: '18645689658',
          number: '00125634878',
          time: '2019/06/24 15:08:56'
        }],
      // 客户签收
      customerEvaluate: {
        'demandId': 0,
        'settlementPrice': 0,
        'feedbackContent': '',
        'serviceAttitude': 4,
        'serviceQuality': 4,
        'serviceResponse': 4,
        'demandOssRelationEntityList': []
      },
      fileList: [], // 附件
      // 投诉数据
      complaintData: {
        demandId: '',
        complaintContent: '',
        demandOssRelationEntityList: []
      },
      getLineBottom: '30px'
    }
  },
  computed: {
    demandId () {
      return this.$route.query.id
    }
  },
  components: {
    // Repair
  },
  watch: {
    demandId (val) {
      if (val) {
        this.getInfo()
      } else {
      }
    }
  },
  created () {
    if (this.demandId) {
      this.getInfo()
      window.addEventListener('beforeunload', this.deleteOssId)
    }
  },
  methods: {
    getInfo () {
      this.fileList = []
      this.customerEvaluate.demandId = 0
      this.customerEvaluate.settlementPrice = 0
      this.customerEvaluate.feedbackContent = ''
      this.customerEvaluate.serviceAttitude = 5
      this.customerEvaluate.serviceQuality = 5
      this.customerEvaluate.serviceResponse = 5
      this.customerEvaluate.demandId = 0
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/consumer/demand/customer/info/${this.demandId}`)
        .then(({ data }) => {
          if (data && data.data && data.code === 0) {
            if (data.data.demandStatus === null || data.data.demandStatus === undefined) {
              this.activeIndex = 0
            } else if (data.data.demandStatus === 6) {
              this.activeIndex = 2
            } else if (data.data.demandStatus === 7) {
              this.activeIndex = 0
            } else if (data.data.demandStatus === 4) {
              this.activeIndex = 3
            } else if (data.data.demandStatus === 3) {
              this.activeIndex = 2
            } else {
              this.activeIndex = data.data.demandStatus
            }
            // 已关闭 重写进度条数据，根据步骤重写
            if (data.data.demandVo && data.data.demandVo.status === 5) {
              let stepsArr = this.steps.splice(0, this.activeIndex + 1)
              stepsArr.push({
                ind: 2,
                key: '',
                name: '已关闭'
              })
              this.stepsDemand = stepsArr
              this.activeIndex = stepsArr.length
            }
            // this.activeIndex = data.result.data.demandStatus === 6 ? 2 : data.result.data.demandStatus
            this.detailInfo = data.data
            this.transferList = data.data.historyAcceptance || []
            this.currentPerson = this.transferList ? this.transferList.slice(this.transferList.length - 1)[0] : null
            if (data.data.demandStatus >= 3) {
              // this.getOssKey()
            }
            // if (this.detailInfo.demandPipelineRecord) {}
            let conent = ''
            if (this.detailInfo.demandStatus === null || this.detailInfo.demandStatus === undefined) {
              conent = '需求提交'
            } else if (this.detailInfo.demandStatus === 0) {
              conent = '等待人员派遣'
            } else if (this.detailInfo.demandStatus === 1) {
              conent = '等待服务受理'
            } else if (this.detailInfo.demandStatus === 2) {
              conent = '等待客户确认受理单'
            } else if (this.detailInfo.demandStatus === 3) {
              // if (this.detailInfo.settlementPrice !== '' && this.detailInfo.settlementPrice !== null) {
              if (this.detailInfo.demandServiceList.length > 0 &&
                this.detailInfo.serviceStatus) {
                conent = '等待客户签收'
              } else {
                conent = '现场服务'
              }
              // } else {
              //   conent = '等待现场实施'
              // }
            } else if (this.detailInfo.demandStatus === 4) {
              conent = '等待客户付款'
            } else if (this.detailInfo.demandStatus === 5) {
              conent = '完成'
            } else if (this.detailInfo.demandStatus === 4) {
              conent = '已撤销'
            }
            if (conent !== '') {
              if (detailInfo.demandVo.status !== 5) {
                this.detailInfo.demandPipelineRecord.push({
                  createTime: '',
                  demandOperationContent: conent,
                  userContent: ''
                })
              }
            }
            this.getLineBottom = '30px'
            this.$nextTick(() => {
              let arr = Array.prototype.slice.call(document.getElementsByClassName('timeline-small-body-ul-li'))
              if (arr.length) {
                let height = arr[arr.length - 1].clientHeight
                this.getLineBottom = (height > 40 ? height - 10 : 30) + 'px'
              }
            })
          }
        })
    },
    // 受理单确认
    confirmAcceptance () {
      if (this.subLoading) {
        return false
      }
      this.subLoading = true
      let _this = this
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/demand/updateCustomerConfirmAcceptance`,
        {
          'serviceAcceptanceId': this.detailInfo.serveAcceptance.serviceAcceptanceId,
          'demandId': this.detailInfo.demandId,
          'serviceCost': this.detailInfo.serveAcceptance.serviceCost
        })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: '客户确认成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                _this.$router.go(-1)
                _this.subLoading = false
              }
            })
          } else {
            this.subLoading = false
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 签收确认
    signConfirm () {
      if (this.subLoading) {
        return false
      }
      if (!this.demandId) {
        this.$message.error('无需求ID不可签收')
        return false
      }
      let _this = this
      this.subLoading = true
      this.customerEvaluate.demandId = this.detailInfo.demandId
      this.customerEvaluate.settlementPrice = this.detailInfo.settlementPrice
      if (this.fileList.length) {
        this.customerEvaluate.demandOssRelationEntityList = this.fileList.map(item => {
          return { aliOssId: item.ossId }
        })
      }
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/demandcustomersign/save`, this.customerEvaluate)
        .then(({ data }) => {
          // console.log(data, 'signConfirm')
          if (data && data.code === 0) {
            this.subFlag = true
            this.$message({
              message: '签收成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                _this.$router.go(-1)
                _this.subLoading = false
              }
            })
          } else {
            this.subLoading = false
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 投诉取消
    cancelUpload () {
      this.complaintVisible = false
      this.complaintData.complaintContent = ''
      this.complaintData.demandOssRelationEntityList = []
      if (!this.subFlag) {
        this.fileList.forEach(item => {
          this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/${item.ossId}`)
        })
      }
      this.fileList = []
    },
    // 投诉提交
    submitUpload () {
      if (this.subLoading) {
        return false
      }
      if (!this.detailInfo.demandId) {
        this.$message.error('无需求ID不可投诉')
        return false
      }
      let _this = this
      this.subLoading = true
      // this.complaintVisible = false
      this.complaintData.demandId = this.detailInfo.demandId
      if (this.fileList.length) {
        this.complaintData.demandOssRelationEntityList = this.fileList.map(item => {
          return { aliOssId: item.ossId }
        })
      }
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/demandcomplaint/save`, this.complaintData)
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.subFlag = true
            this.$message({
              message: '投诉成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                // _this.$router.go(-1)
                _this.subLoading = false
                _this.cancelUpload()
                _this.getInfo()
              }
            })
          } else {
            this.subLoading = false
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    handleRemove () {
    },
    // 删除需求
    deleteDemand () {
      if (this.subLoading) {
        return false
      }
      let _this = this
      this.subLoading = true
      this.$confirm(`确定对删除该数据?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/demandpayment/demandlist/delete`, {
            ids: [this.demandId]
          })
            .then(() => {
              this.$message({
                message: '删除成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  _this.$router.go(-1)
                  _this.subLoading = false
                }
              })
            })
            .catch(() => {
              // console.log(err, 'err')
              this.subLoading = false
            })
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 撤销需求
    revokeDemand () {
      if (this.subLoading) {
        return false
      }
      let _this = this
      this.subLoading = true
      this.$confirm(`确定对撤回该数据?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/demandpayment/demandserviceacceptance/customerCancelAcceptance/${this.demandId}`)
            .then(() => {
              this.$message({
                message: '撤回成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  _this.$router.go(-1)
                  _this.subLoading = false
                }
              })
            })
            .catch(() => {
              this.subLoading = false
            })
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    transback () {
      if (this.transferViewIndex < (this.transferList.length - 3)) {
        let oldTransferViewIndex = this.transferViewIndex
        this.transferViewIndex = oldTransferViewIndex + 1
        this.transTo(this.transferViewIndex)
      }
    },
    transforward () {
      if (this.transferViewIndex > 0) {
        let oldTransferViewIndex = this.transferViewIndex
        this.transferViewIndex = oldTransferViewIndex - 1
        this.transTo(this.transferViewIndex)
      }
    },
    transTo (index) {
      this.trnasferDistance = `-${index * 250}px`
    },
    formatFormData () {
      this.customerEvaluate.demandId = 0
      this.customerEvaluate.settlementPrice = 0
      this.customerEvaluate.feedbackContent = ''
      this.customerEvaluate.serviceAttitude = 5
      this.customerEvaluate.serviceQuality = 5
      this.customerEvaluate.serviceResponse = 5
      this.customerEvaluate.demandId = 0
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        this.$router.push({ name: name })
      } else {
        this.formatFormData()
        this.$router.go(-1)
      }
    },
    download (item) {
      var a = document.createElement('a')
      a.href = item.objectName
      a.setAttribute('target', '_blank')
      a.click()
      // document.body.removeChild(a)
    },
    // 页面关闭时清理OSS文件
    deleteOssId () {
      let deleteIds = []
      if (!this.subFlag) {
        deleteIds = this.fileList.map(item => {
          return item.ossId
        })
      }
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/fileupload/sys/deleteBatchAliOss`, deleteIds)
        .then(item => {
          this.fileList = []
        })
        .catch(() => {
        })
      window.removeEventListener('beforeunload', this.deleteOssId)
    },
    // 上传失败
    errorFile () {
      this.subLoading = false
    },
    // 上传成功
    successFile (response, file, fileList) {
      if (response.code === 0) {
        this.fileList.push({
          uid: file.uid,
          ossId: response.data.aliOssId,
          ossName: response.data.objectName,
          url: response.data.url,
          name: response.data.fileName
          // uploadId: checkpoint.uploadId
        })
        this.subLoading = false
      } else {
        // console.log(this.$refs.upLoadFile.onRemove(file, fileList), file)
        // file.onError(file)
        this.$refs.upLoadFile.abort(file) // upload: el-upload的ref值；file:File类型，file文件本身
        fileList.splice(fileList.indexOf(file), 1) // fileList: 文件列表，钩子函数中的fileList
        this.removeFile(file, fileList)
        this.$message.error(response.result.msg || '上传失败')
        this.subLoading = false
      }
    },
    // 上传
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
    },
    // 删除文件
    removeFile (file, fileList) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId) {
        let index = this.fileList.findIndex(item => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/fileupload/sys/deleteBatchAliOss`, [this.fileList[index].ossId])
            .then(item => {
              this.fileList.splice(index, 1)
            })
            .catch(() => {
            })
        }
      }
    }
  },
  beforeDestroy () {
    this.deleteOssId()
  }
}
</script>
<style scoped>
.right-menu-name {
  margin: 20px 0;
  padding: 0;
}
.pointer {
  user-select: none;
  cursor: pointer;
}
.wyts {
  position: absolute;
  right: 0;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  width: 100px;
  height: 30px;
  text-align: center;
  line-height: 30px;
}
.wyts:hover {
  background: #1d65a8;
  color: #ffffff;
}
.overell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.box-shadow {
  background-color: #ffffff;
  -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px;
  -moz-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px;
}
ul,
li {
  list-style: none;
}
.container {
  width: 1190px;
  /* transform: scale(0.9);
  transform-origin: 0 0; */
  margin: 0 auto;
  word-wrap: break-word;
  word-break: break-all;
}
.body-conent {
  margin: 20px 0;
}
.body-info h2 {
  font-size: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 30px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
/* 需求单基本信息开始 */
.demand-info {
  /* background-color: #F8F8F8; */
  border: 1px solid #eeeeee;
}
.demand-back {
  padding-top: 20px;
  background-color: #f8f8f8;
}
.row .demand-textarea {
  width: 90%;
  font-size: 14px;
  line-height: 30px;
  margin: 0 30px 40px 0px;
  padding-right: 0px;
}
.inquiryfj {
  padding-left: 8px;
  display: flex;
  flex-wrap: wrap;
}
.inquiryfj li {
  padding-left: 5px;
  width: 100px;
  position: relative;
}
.inquiryfjx {
  position: absolute;
  right: 0px;
  top: 0;
  width: 20px;
  height: 20px;
}
.inquiryfj li img {
  width: 95px;
  height: 95px;
  cursor: pointer;
}
.inquiryfj li p {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  font-weight: bold;
}
/* 需求单基本信息结束 */
.row {
  display: flex;
  /* margin: 10px 0; */
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 12px;
}
.row-item {
  width: 350px;
  line-height: 30px;
  display: flex;
  font-size: 14px;
}
.row-item-label {
  display: inline-block;
  min-width: 110px;
  text-align: right;
  color: #666;
  font-size: 14px;
  line-height: 30px;
}
.row-item-input {
  width: 210px;
  /* border: 1px solid #eee; */
  padding-left: 10px;
  color: #333;
}
.row-item-textarea {
  /* border: 1px solid #eee; */
  padding-left: 10px;
  padding: 0 10px;
  margin-left: 10px;
  font-size: 14px;
  line-height: 30px;
  /* width: 90%; */
}
/* .row-detail-item{
  margin-left: 10px;
} */
.row-item-title {
  font-size: 14px;
}
.row-item-conent {
  font-size: 14px;
  max-width: 600px;
  color: #666666;
  padding-left: 10px;
}
/* .row-item-select{
  width: 60%;
} */
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
.el-step__head.is-success {
  color: #1d65a8 !important;
  border-color: #1d65a8 !important;
}
.sjz {
  display: flex;
  justify-content: center;
  line-height: 40px;
  padding: 20px 70px;
  background-color: #fff;
}
.sjz-kuaikuai {
  display: flex;
  flex: 1;
}
.sjz-line {
  margin-top: 30px;
  flex: 1;
}
.sjz-item {
  width: 70px;
}
.sjz-icon {
  background: #ffffff;
  border: 1px solid #1d65a8;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin: 10px;
  margin-left: 15px;
  line-height: 38px;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
}
.sjz-icon .sjc-num {
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
}
.sjz-undone {
  color: #cacaca;
  border: 1px solid #cacaca;
}
.sjz-do {
  background-color: #1d65a8;
  color: #fff;
}
.sjz-icon .el-icon-check {
  font-size: 30px;
  line-height: 38px;
  font-weight: 900;
  color: #1d65a8;
}
.sjz-word {
  /* padding-left: 10px; */
  color: #1d65a8;
  text-align: center;
  width: 100%;
}
.sjz-line {
  height: 2px;
  background: #1d65a8;
  width: 20px;
}
/* 情况详细 */
.demand-detail-info {
  display: flex;
  padding-right: 30px;
  margin-bottom: 30px;
}
.left-label {
  background: #5979f1;
  text-align: center;
  width: 40px;
  min-height: 202px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.left-label-fwjl {
  background: #4a90e2;
}
.left-label-qsqk {
  background: #23aad7;
}
.left-label-tsxx {
  background: #18cac6;
}
.end-confirm {
  width: 241px;
  margin: 30px;
  margin-right: 0;
  text-align: center;
  border-left: 1px solid #eeeeee;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.end-confirm-status {
  height: 36px;
  line-height: 36px;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  margin-bottom: 30px;
}
.end-confirm-status img {
  width: 34px;
  height: 36px;
}
.end-confirm-cancle {
  border: 1px solid #1d65a8;
  background: #fff;
  width: 100px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #1d65a8;
  font-size: 14px;
}
.end-confirm-ok {
  border: 1px solid #1d65a8;
  background: #1d65a8;
  width: 100px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 14px;
}
.end-confirm-time {
  text-align: right;
}
.right-content {
  /* flex: 1; */
  width: 780px;
  padding: 20px;
  padding-right: 0;
  font-size: 14px;
}
.right-content h3 {
  font-size: 14px;
  color: #333333;
  height: 20px;
  line-height: 20px;
  margin-bottom: 12px;
}
/* 人员派遣 */
.current-acceptance-or {
  width: 249px;
  border: 1px solid #1d65a8;
  position: relative;
}
.current-acceptance-or img {
  width: 247px;
  height: 160px;
}
.current-label {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #1d65a8;
  width: 80px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  height: 17px;
  line-height: 17px;
}
.current-info {
  padding: 20px 20px 18px;
  line-height: 30px;
}
.history-list {
  margin-top: 20px;
  display: flex;
}
.opt-left {
  width: 30px;
  height: 280px;
  line-height: 280px;
  text-align: center;
  border: 1px solid #eeeeee;
  user-select: none;
  cursor: pointer;
}
.opt-left .el-icon-arrow-left {
  font-size: 20px;
}
.opt-left .el-icon-arrow-right {
  font-size: 20px;
}
.opt-posation {
  margin-right: 0px;
}
/* .history-info{
  padding-bottom: 0;
} */
.his-item {
  width: 219px;
  /* text-align: center; */
  margin: 0 8px;
  border: 1px solid #eeeeee;
}
.his-info {
  padding: 16px 20px 9px;
  font-size: 12px;
  color: #666666;
  line-height: 27px;
}
.his-line {
  line-height: 279px;
  transform: rotate(180deg);
}

.timeline-small {
  /* max-width: 350px; */
  /* max-height: 630px; */
  /* overflow: hidden; */
  padding-right: 100px;
  width: 100%;
  /* margin: 30px auto 0; */
  box-shadow: 0 0 40px #a0a0a0;
  font-family: "Open Sans", sans-serif;
}
.timeline-small-body {
  position: relative;
}
.timeline-small-body ul {
  line-height: 20px;
  width: 100%;
  padding: 0 0 0 100px;
  margin: 0;
  list-style: none;
  position: relative;
}
.timeline-small-body .line {
  content: "";
  /* height: 100%; */
  width: 2px;
  border-left: 1px dashed #cacaca;
  /* background-color: #d9d9d9; */
  position: absolute;
  top: 30px;
  bottom: 30px;
  left: 109px;
  z-index: 100;
}
.timeline-small-body li {
  display: flex;
  padding: 10px 0;
}
.timeline-small-body li:last-of-type .bullet {
  background: #1d65a8;
}
/* .timeline-small-body li div {
  display: inline-block;
  vertical-align: top;
} */
.bullet {
  width: 20px;
  height: 20px;
  /* box-sizing: border-box; */
  border-radius: 50%;
  background: #fff;
  z-index: 1;
  margin-right: 90px;
  background-color: #cacaca;
  /* margin-top: 7%; */
}
/* .bullet.pink {
} */
.timeline-small-body .bullet:last-child {
  background-color: #1d65a8;
}
.timeline-small-body .date {
  width: 210px;
  font-size: 14px;
  /* padding-top: 0.40rem;
  padding-right: 2rem; */
}
.timeline-small-body .desc {
  width: 580px;
  display: flex;
  line-height: 20px;
  /* width: 50%; */
}
.record-status {
  width: 120px;
}
.record-time {
  width: 60px;
}
.record-info {
  width: 180px;
}
.jg-distance {
  flex: 1;
}
.label-vertical {
  padding: 0 7px;
}
.rate-choose {
  line-height: 40px;
  padding-left: 20px;
  text-align: center;
  transform: scale(1.4);
}
.rate-choose-normal {
  line-height: 40px;
  transform: scale(1.4);
  padding-left: 10px;
}
.transferList {
  transition: 0.5s ease-in-out;
  height: 280px;
  white-space: nowrap;
}
.transferList li {
  display: inline-flex;
  width: 250px;
}
.viewWindow {
  width: 750px;
  overflow: hidden;
}
.not-allow {
  cursor: not-allowed;
  background: #eeeeee;
}
.sign-but {
  background: #1d65a8;
  border: 1px solid #1d65a8;
  width: 161px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 16px;
}
.cancle-but {
  margin-left: 10px;
  /* background: #1D65A8; */
  border: 1px solid #1d65a8;
  width: 161px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #1d65a8;
  font-size: 16px;
}
.cancle-but:hover {
  background: #1d65a8;
  color: #fff;
}
.pointer:hover {
  background: #1d65a8;
  color: #fff;
}
/* 签收附件 */
.fj-item {
  width: 95px;
  padding: 5px;
}
.fj-item img {
  width: 85px;
  height: 85px;
}
.but-complaint {
  width: 265.5px;
  border-radius: 0;
  height: 52px;
  text-align: center;
  background: #1d65a8;
  color: white;
  text-align: center;
  line-height: 50px;
  flex: 1;
  user-select: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: normal;
}
</style>
